export default __webpack_public_path__ + "bml-characteristic4.3809c7c.png";